<template>
    <div class="row">
        <div class="col-12 col-md-11 col-lg-8 offset-md-1 offset-lg-2">
            <p class="title center-sm">Strafrecht</p>
            <p class="mt-5">In Strafsachen verteidige ich in Ermittlungsverfahren und Hauptverhandlungen. Hier ist es für Sie besonders wichtig, sich so früh wie möglich mit mir in Verbindung zu setzen - also sofort, wenn Sie die Vorladung zur Vernehmung als Beschuldigter von der Polizei erhalten haben. Nicht selten ist eine erfolgreiche Verteidigung nicht mehr möglich, wenn Sie bereits selbst ohne anwaltliche Beratung mit der Polizei oder anderen staatlichen Stellen im Ermittlungsverfahren gesprochen haben. </p>
          <p class="mt-5">Überwiegend verteidige ich in Verfahren wegen</p>
          <ul class="margin-sm">
        <li>Sachbeschädigung,</li>
        <li>Körperverletzung,</li>
        <li>unerlaubtem Entfernen vom Unfallort,</li>
        <li>Betrug,</li>
        <li>Diebstahl,</li>
        <li>Nachstellung,</li>
        <li>Brandstiftung,</li>
        <li>Beleidigung oder</li>
        <li>übler Nachrede.</li>
          </ul>
          <p class="mt-5">Ebenfalls verteidige ich in Bußgeldverfahren und hier insbesondere in Verfahren wegen Ordnungswidrigkeiten im Straßenverkehr.</p>
        </div>
        <div class="col-12 col-md-8 col-lg-8 offset-md-1 offset-lg-2 mt-5">
            <p class="center-sm">Weitere Schwerpunkte:</p>
            <ul class="fields-of-law margin-sm">
                <li><a @click.prevent="$emit('routeTo', 'lot')" href="#">Mietrecht</a></li>
                <li><a @click.prevent="$emit('routeTo', 'fl')" href="#">Familienrecht</a></li>
            </ul>
        </div>

    </div>
</template>

<script>
    export default {
        name: "CriminalLaw.vue"
    }
</script>

<style scoped>

</style>